export default __webpack_public_path__ + "static/ak-cached/24h/media/hbo max.691c6960.png";